import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import ButtonGroup from '@mui/material/ButtonGroup';
import { DriveOnDisplayableTaskDto as DriveonTask } from '@/generated/model';
import { DisplayTask } from '@/components/logbook/task/DisplayTask';
import AssistantDirectionOutlinedIcon from '@mui/icons-material/AssistantDirectionOutlined';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { IconButton } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import { ReactElement, useState } from 'react';
import { MapAppPicker } from '@/components/common/MapAppPicker';

import './TaskDetailDialog.css';

type TaskDetailDialogProps = {
  task: DriveonTask;
  onClose: () => void;
  checkIfEmpty(label: string | undefined | 0): string;
};

export function TaskDetailDialog({ task, onClose, checkIfEmpty }: TaskDetailDialogProps) {
  const { t } = useTranslation();
  const [gpsDialog, setGpsDialog] = useState<ReactElement | undefined>(undefined);
  const [addressDialog, setAddressDialog] = useState<ReactElement | undefined>(undefined);

  function showAddressDialog() {
    function onClose() {
      setAddressDialog(undefined);
    }

    setAddressDialog(<MapAppPicker type={'address'} task={task} onClose={onClose} />);
  }

  function showGpsDialog() {
    function onClose() {
      setGpsDialog(undefined);
    }

    setGpsDialog(<MapAppPicker type={'gps'} task={task} onClose={onClose} />);
  }

  return (
    <>
      <Dialog open={true}>
        <DialogTitle>
          <Stack direction={'row'} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography sx={{ fontWeight: 'bold', size: 24 }}>
              {t('menetlevel.taskdetails.eventusid')}: {checkIfEmpty(task.eventusId)}
            </Typography>
            <IconButton>
              <CloseOutlined onClick={() => onClose()} />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent dividers>
          <DisplayTask task={task} checkIfEmpty={checkIfEmpty} />
        </DialogContent>
        <DialogActions>
          <ButtonGroup fullWidth orientation="vertical" variant='contained'> 
            <Button
              fullWidth
              variant="contained"
              startIcon={<AssistantDirectionOutlinedIcon />}
              sx={{ 
                margin: '2px',
                color: 'white', 
                backgroundColor: 'darkgrey !important' }}
              onClick={() => showAddressDialog()}
              // style={{ height: '100px' }}
            >
              {t('menetlevel.taskdetails.navigateaddress')}
            </Button>
            <Button
              fullWidth
              variant="contained"
              startIcon={<AssistantDirectionOutlinedIcon />}
              sx={{
                margin: '2px',
                color: 'white', 
                backgroundColor: 'grey !important' }}
              onClick={() => showGpsDialog()}
              // style={{ height: '100px' }}
            >
              {t('menetlevel.taskdetails.navigategps')}
            </Button>
          </ButtonGroup>
        </DialogActions>
      </Dialog>
      {addressDialog}
      {gpsDialog}
    </>
  );
}
